/**
 * AlertComp Component
 * 
 * Global alert dialog component
 * - Shows alert messages from Redux state (info.show_alert, info.alert_msg)
 * - Single "close" button to dismiss
 * - Used for error messages and important notifications
 * 
 * @component
 */
import * as React from 'react';
import { Button, Dialog, Portal, Paragraph } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { hideAlert } from '../store/info.slice';

const AlertComp = () => {
  const dispatch = useDispatch();
  const show_alert = useSelector((state) => state.info?.show_alert);
  const alert_msg = useSelector((state) => state.info?.alert_msg);
  const [visible, setVisible] = React.useState(show_alert);
  const [msg, setMsg] = React.useState(alert_msg);

  useEffect(() => {
    setVisible(show_alert);
    setMsg(alert_msg);
  }, [show_alert, alert_msg]);

  const hideDialog = () => {
    setVisible(false);
    dispatch(hideAlert());
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={hideDialog}>
        <Dialog.Title>Alert</Dialog.Title>
        <Dialog.Content>
          <Paragraph>{msg}</Paragraph>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={hideDialog}>close</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default AlertComp;
